module.exports = __webpack_public_path__ + "static/media/noDataFound3.4ad2cc43.svg";